import { ApButtonText, colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 48px;
  border-top: 1px solid ${colors.grey4};
  border-bottom: 1px solid ${colors.grey4};
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  max-width: 50%;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  margin-left: 40px;
`;

export const FileName = styled(ApButtonText)`
  margin-left: 4px;
  color: ${colors.green2};
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  span {
    justify-content: flex-start;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
`;

export const FileStatus = styled.div`
  font-size: 11px;
  color: ${colors.grey8};
  margin-left: 8px;
  white-space: nowrap;
`;

export const PublishedInfo = styled.div`
  font-size: 11px;
  color: ${colors.black};
  margin-right: 8px;
  white-space: nowrap;
`;

export const DeleteAllDataContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DeleteAllText = styled.div`
  font-size: 16px;
  color: ${colors.grey7};
  letter-spacing: 0.3px;
  font-weight: 400;
`;

export const NoDataText = styled.div`
  font-size: 16px;
  color: ${colors.grey8};
  font-weight: 400;
  margin-left: 8px;
`;

export const DownloadConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DownloadConfirmText = styled.div`
  color: ${colors.black};
  font-size: 16px;
  margin-bottom: 4px;
`;

export const DownloadConfirmItalicText = styled(DownloadConfirmText)`
  font-style: italic;
`;

export const DownloadConfirmTextAgree = styled(DownloadConfirmText)`
  margin-top: 24px;
  text-align: center;
`;
